import React from 'react';
import HeroImage from "../assets/heroImage.png";
import { motion } from "framer-motion";

const Home = () => {
  const scrollToPortfolio = () => {
    const el = document.getElementById("Projects");
    if (el?.scrollIntoView) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const scrollToExperience = () => {
    const el = document.getElementById("experience") || document.getElementById("Experience");
    if (el?.scrollIntoView) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div
      name="home"
      id="home"
      className="min-h-screen w-full pt-28 md:pt-40 transition-colors duration-300
                 bg-gradient-to-br from-gray-50 via-white to-gray-100
                 dark:from-gray-900 dark:via-black dark:to-gray-800"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-8 flex flex-col items-center justify-center h-full md:flex-row gap-6 md:gap-8">
        {/* Text Content */}
        <motion.div
          className="flex flex-col justify-center h-full order-2 md:order-1 text-center md:text-left"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-3xl xs:text-4xl sm:text-5xl font-bold mb-2 text-gray-900 dark:text-white">
            Mohammed Yassine Aoulad Ahriz
          </h1>

          <h2 className="text-lg sm:text-xl md:text-2xl font-semibold mb-4 text-cyan-700 dark:text-cyan-400">
            QA Automation • DevOps • Full‑Stack Developer
          </h2>

          {/* Focus badges */}
          <div className="flex flex-wrap justify-center md:justify-start gap-2 mb-5">
            <span className="text-xs sm:text-sm px-3 py-1 rounded-full border
                              bg-white text-cyan-700 border-cyan-100
                              dark:bg-gray-800 dark:text-cyan-400 dark:border-gray-700">
              Playwright • Selenium • Cucumber
            </span>
            <span className="text-xs sm:text-sm px-3 py-1 rounded-full border
                              bg-white text-indigo-700 border-indigo-100
                              dark:bg-gray-800 dark:text-indigo-300 dark:border-gray-700">
              GitHub Actions • CI/CD
            </span>
            <span className="text-xs sm:text-sm px-3 py-1 rounded-full border
                              bg-white text-emerald-700 border-emerald-100
                              dark:bg-gray-800 dark:text-emerald-300 dark:border-gray-700">
              React • Laravel • Express
            </span>
          </div>

          <p className="text-sm sm:text-base md:text-lg max-w-2xl mb-6 sm:mb-8 text-gray-700 dark:text-gray-300">
            I design reliable software and the pipelines that validate it. My focus is end‑to‑end quality:
            scalable <span className="text-cyan-700 dark:text-cyan-400">test automation</span> with Playwright/Selenium,
            production‑ready <span className="text-cyan-700 dark:text-cyan-400">CI/CD</span> using GitHub Actions,
            and hands‑on <span className="text-cyan-700 dark:text-cyan-400">full‑stack</span> development with modern frameworks.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center md:justify-start">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={scrollToPortfolio}
              className="group inline-flex items-center gap-2 px-5 py-2 sm:px-6 sm:py-3 rounded-lg shadow-lg transition-all duration-300
                         bg-gradient-to-r from-cyan-500 to-blue-600 text-white
                         hover:shadow-cyan-500/20 focus:outline-none focus:ring-2 focus:ring-cyan-400/60"
              aria-label="Explore my projects"
            >
              <span className="font-medium text-sm sm:text-base">Projects</span>
            </motion.button>

            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={scrollToExperience}
              className="group inline-flex items-center gap-2 px-5 py-2 sm:px-6 sm:py-3 rounded-lg border
                         bg-white text-cyan-700 border-cyan-200
                         hover:border-cyan-400 hover:text-cyan-800
                         dark:bg-transparent dark:text-cyan-300 dark:border-gray-700
                         dark:hover:border-cyan-500 dark:hover:text-cyan-400 transition-all"
              aria-label="See QA & DevOps experience"
            >
              <span className="font-medium text-sm sm:text-base">Experience</span>
            </motion.button>
          </div>
        </motion.div>

        {/* Image */}
        <motion.div
          className="order-1 md:order-2 mb-6 md:mb-0"
          initial={{ opacity: 0, scale: 0.94 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
        >
          <div className="relative">
            <div className="absolute -inset-2 rounded-2xl opacity-80 blur-md bg-gradient-to-r from-cyan-500 to-blue-600"></div>
            <img
              src={HeroImage}
              alt="Portrait of Mohammed Yassine"
              className="relative w-56 h-56 xs:w-64 xs:h-64 sm:w-80 sm:h-80 object-cover rounded-2xl
                         border-2 border-cyan-500/30 dark:border-cyan-400/30 shadow-xl"
            />
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Home;